export const LanguageData = [
  { title: "Sort By Language" },
  { title: "English" },
  { title: "Arabic" },
  { title: "French" },
  { title: "German" },
  { title: "Spanish" },
  { title: "Italian" },
  { title: "Russian" },
  { title: "Chinese" },
  { title: "Japanese" },
  { title: "Korean" },
  { title: "Hindi" },
  { title: "Urdu" },
  { title: "Turkish" },
  { title: "Portuguese" },
  { title: "Dutch" },
  { title: "Swedish" },
  { title: "Danish" },
  { title: "Norwegian" },
  { title: "Finnish" },
  { title: "Indonesian" },
  { title: "Malay" },
  { title: "Thai" },
  { title: "Vietnamese" },
  { title: "Hebrew" },
  { title: "Greek" },
  { title: "Polish" },
  { title: "Romanian" },
  { title: "Swahili" },
];

export const RatesData = [
  { title: "Sort By Rates" },
  { title: "1 Star" },
  { title: "2 Star" },
  { title: "3 Star" },
  { title: "4 Star" },
  { title: "5 Star" },
];

export const TimesData = [
  { title: "Sort By Hours" },
  { title: "2 Hours" },
  { title: "3 Hours" },
  { title: "4 Hours" },
];

export const YearData = [
  { title: "Sort By Year" },
  { title: "2023" },
  { title: "2022" },
  { title: "2021" },
  { title: "2020" },
  { title: "2019" },
  { title: "2018" },
  { title: "2017" },
  { title: "2016" },
  { title: "2015" },
  { title: "2014" },
  { title: "2013" },
  { title: "2012" },
  { title: "2011" },
  { title: "2010" },
  { title: "2009" },
  { title: "2008" },
  { title: "2007" },
  { title: "2006" },
  { title: "2005" },
  { title: "2004" },
  { title: "2003" },
  { title: "2002" },
  { title: "2001" },
  { title: "2000" },
];
